import React, { Component } from 'react';
import './index.less';

const flexSuppport = () => {
  const dom = document.createElement('div')
  dom.style.display = 'flex'
  return dom.style.display === 'flex'
}
const tag = {
  tip: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B915FF605380017', '签名区'),
  title: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B915FF605380018', '请在下面指定区域签名'),
  actions: {
    undo: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B915FF605380019', '后退'),
    redo: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B915FF60538001A', '前进'),
    colorSet: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B915FF60538001B', '颜色'),
    lineWidthSet: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B915FF60538001C', '粗细'),
    clear: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B915FF60538001D', '清空'),
    back: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B915FF60538001E', '返回'),
    save: lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_1B915FF60538001F', '完成')
  }
}
export default class HandWritingBoard extends Component {
  constructor (props) {
    super(props);
    const _options = Object.assign({
      width: 500,
      height: 300,
      el: document.getElementById('Editor-Content-body') || document.body,
    }, props.extendProperties)
    this.state = {
 
    };
    Object.assign(this, _options)
    this.drawStack = []
    this.strokeStyle = '#000'
    this._cursor = -1
    this.shadowBlur = 1
    this.lineWidth = 5
    this.shadowColor = '#000'
    this.colorIndex = 0
    this.lineWidthIndex = 1
    this.colorsPool = ['000', 'ff002e', '37b7fd']
    this.lineWidthPool = [2, 5, 8, 12]
    this.colorIndex = 0
    this.lineWidthIndex = 1
  }

  adjustDim () {
    const width = this.canvasWrapper.clientWidth
    const height = this.canvasWrapper.clientHeight 

    this.canvas.setAttribute('width', width)
    this.canvas.setAttribute('height', height)
  }

  bindEvents () {
    this.canvas.addEventListener('mousedown', e => {
      this.mseHold = true
      const position = this.getPosition(e)
      this.ctx.beginPath()
      this.ctx.moveTo(position.x, position.y)
    })

    // 窗口大小改变重置画布纠正坐标
    window.addEventListener('resize', e => {
      this.adjustDim()
      this.renderStack()
    })

    this.canvas.addEventListener('mousemove', (e) => {
      if (!this.mseHold) return

      e.preventDefault()
      e.stopPropagation()
      let position = this.getPosition(e)
      if (!position) return
      this.ctx.lineTo(position.x, position.y)
      this.ctx.shadowBlur = this.shadowBlur
      this.ctx.shadowColor = this.shadowColor
      this.ctx.lineWidth = this.lineWidth

      this.ctx.lineCap = 'round'

      this.ctx.stroke()
    })
    this.canvas.addEventListener('mouseup', () => {
      let newStack = this.canvas.toDataURL('image/png')
      this.mseHold = false
      const saveStack = function () {
        if (this.cursor !== this.drawStack.length - 1) {
          this.drawStack = this.drawStack.slice(0, this.cursor + 1)
        }
        this.drawStack.push(newStack)
        this.cursor++
      }
      saveStack.call(this)
      // this.el.querySelector('.tip').style.display = 'none'
    })
  }

  getPosition (e) {
    const CBR = this.canvas.getBoundingClientRect()

    return {
      x: e.clientX - CBR.left,
      y: e.clientY - CBR.top
    }
  }

  getCanvasBound () {
    let canvasBound = this.canvas.getBoundingClientRect()
    return {
      x: canvasBound.left,
      y: canvasBound.top,
      w: canvasBound.width,
      h: canvasBound.height
    }
  }

  clear (ignoreCursor) {
    let canvasBound = this.getCanvasBound()
    this.ctx.clearRect(0, 0, canvasBound.w, canvasBound.h)
    if (ignoreCursor) return
    this.drawStack = []
    this.cursor = -1
  }

  undo () {
    if (this.cursor === -1) return
    this.cursor--
    this.renderStack()
  }

  redo () {
    if (this.cursor === this.drawStack.length - 1) return
    this.cursor++
    this.renderStack()
  }

  colorSet () {
    const curColor = '#' + this.colorsPool[++this.colorIndex % 3]
    this.ctx.strokeStyle = curColor
    this.shadowColor = curColor
    this.container.querySelector('[data-action="colorSet"]').style.backgroundColor = curColor
  }

  lineWidthSet (e) {
    const offset = 5
    const eTarget = e.target
    const LI_ACTIVE_CLASS = 'active'

    let lineWidthDropDown = this.container.querySelector('.lne-wdth-drp')
    if (!lineWidthDropDown) {
      lineWidthDropDown = document.createElement('ul')
      lineWidthDropDown.className = 'lne-wdth-drp'
      const lis = []
      this.lineWidthPool.forEach((v, index) => {
        const li = document.createElement('li')
        if (index === this.lineWidthIndex) li.className = LI_ACTIVE_CLASS
        lis.push(li)
        li.style.height = `${v}px`
        lineWidthDropDown.appendChild(li)
        li.onclick = e => {
          lis.forEach($li => {
            $li.className = ''
          })
          this.lineWidth = v
          e.target.className = LI_ACTIVE_CLASS
        }
      })
      document.addEventListener('click', e => {
        if (e.target !== eTarget) {
          lineWidthDropDown.style.display = 'none'
        }
      })
      this.container.appendChild(lineWidthDropDown)
    }
    lineWidthDropDown.style.display = 'block'
    lineWidthDropDown.style.left = `${eTarget.offsetLeft + offset}px`
    lineWidthDropDown.style.top = `${eTarget.offsetTop + eTarget.clientHeight + offset}px`
  }

  back () {
    if (this.el.contains(this.container)) {
      this.el.removeChild(this.container)
      this.props.onCancel(this.drawStack[this.cursor])
    }
  }

  renderStack () {
    this.clear(true)
    let stackSceen = this.drawStack[this.cursor]
    this.ctx.setTransform(1, 0, 0, 1, 0, 0)
    if (!stackSceen) return
    let sceenToDraw = new Image()
    sceenToDraw.src = stackSceen
    sceenToDraw.onload = function () {
      this.ctx.drawImage(sceenToDraw, 0, 0)
    }.bind(this)
  }

  dataURItoBlob (base64Data) {
    let byteString
    if (base64Data.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(base64Data.split(',')[1])
    } else {
      byteString = unescape(base64Data.split(',')[1])
    }
    let mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0]
    let ia = new Uint8Array(byteString.length)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }
    return new Blob([ia], {
      type: mimeString
    })
  }

  save () {
    this.ctx.setTransform(1, 0, 0, 1, 0, 0)
    if (this.el.contains(this.container)) {
      this.el.removeChild(this.container)
      this.props.onSave(this.drawStack[this.cursor])
    }
  }

  get cursor () {
    return this._cursor
  }

  set cursor (val) {
    let redoBtn = this.container.querySelector('.actions [data-action="redo"]')
    let undoBtn = this.container.querySelector('.actions [data-action="undo"]')
    let clearBtn = this.container.querySelector('.actions [data-action="clear"]')
    redoBtn.className = val < this.drawStack.length - 1 ? 'active' : ''
    undoBtn.className = val > -1 ? 'active' : ''
    clearBtn.className = val > -1 ? 'active' : ''
    return this._cursor = val
  }

  init () {
    const dom = document.querySelector('.hw-borad-container')
    if (dom) return
    let canvas
    const container = document.createElement('div')
    container.className = `hw-borad-container ${flexSuppport() ? 'flex fix' : ''}`
    container.style.width = `${this.width + 40}px`
    container.style.height = `${this.height + 115}px`

    const closeBtn = document.createElement('div')
    closeBtn.className = 'close'
    closeBtn.innerHTML = '+'
    closeBtn.addEventListener('click', this.back.bind(this))
    container.appendChild(closeBtn)

    const actionsWrapper = document.createElement('div')
    actionsWrapper.className = 'actions';
    ['undo', 'redo', 'clear', 'colorSet', 'lineWidthSet', 'save'].forEach(action => {
      const actionBtn = document.createElement('a')
      actionBtn.innerHTML = tag['actions'][action]
      actionBtn.setAttribute('data-action', action)
      actionsWrapper.appendChild(actionBtn)
      actionBtn.addEventListener('click', e => {
        if (action == 'clear') {
          this[action]()
        } else {
          this[action](e)
        }
      })
    })
    const btnFolder = document.createElement('span')
    let btnFolded = true
    btnFolder.className = 'btn-folder'
    btnFolder.addEventListener('click', () => {
      btnFolded = !btnFolded
      btnFolder.className = btnFolded ? btnFolder.className.replace('expand', '') : `expand ${btnFolder.className}`
      container.className = !btnFolded ? container.className.replace('hide-btns', '') : `hide-btns ${container.className}`
    })
    actionsWrapper.appendChild(btnFolder)
    container.appendChild(actionsWrapper)

    const canvasWrapper = this.canvasWrapper = document.createElement('div')
    const tip = document.createElement('div')
    canvas = this.canvas = document.createElement('canvas')
    tip.innerHTML = tag['tip']
    tip.className = 'tip'
    canvasWrapper.className = 'canvas-wrapper'
    canvasWrapper.addEventListener('mousedown', e => e.stopPropagation())

    canvasWrapper.appendChild(canvas)
    canvasWrapper.appendChild(tip)
    container.appendChild(canvasWrapper)
    this.container = container
    this.el.appendChild(container)
    setTimeout(() => {
      this.adjustDim()
      this.ctx = canvas.getContext('2d')
      this.ctx.strokeStyle = this.strokeStyle
      this.ctx.shadowBlur = 10
      this.ctx.shadowColor = '#f00'
      this.bindEvents()
    }, 500)
  }

  render () {
    const handWritingBoard = this.init()
    return <div id='Editor-Content-body'>{handWritingBoard}</div>;
  }
}
